import { ComponentDocs } from "components/docs";
import { ComponentExample } from "components/examples";

const FormatNumber = () => (
  <ComponentDocs
    name="<Format.Number/>"
    entry="NumberFormatter"
    propsEntry="NumberFormatterProps"
    namespace="StandardFormatters"
  >
    <ComponentExample
      name="Number formats"
      import={import(
        "examples/Formatters/FormatNumber/FormatNumberFormatsExample"
      )}
      rawImport={import(
        "examples/Formatters/FormatNumber/FormatNumberFormatsExample?raw"
      )}
    />
    {/* TODO custom formats */}
  </ComponentDocs>
);

export default FormatNumber;
